/* eslint-disable no-undef */
module.exports = {
    fancyBox: function () {
        if (typeof Fancybox !== 'undefined' && Fancybox) {
            Fancybox.bind('[data-fancybox]');
        }
    }
};
